export default __webpack_public_path__ + "static/media/IzaberiIkonica.b53dbc92.svg";